<script setup>
  import Layout from "@/layouts/main.vue";
  import PageHeader from "@/components/page-header";
  import '@jobinsjp/vue3-datatable/dist/style.css';
  import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
  import moment from 'moment';
  import { truncate } from 'lodash';
  import Swal from 'sweetalert2';

  import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';

  const store = useStore();
  const loading = computed(() => store.state.globals.loading);
  const violationTypes = computed(() => store.state.violationType.violationTypes);
  const lgus = computed(() => store.state.lgu.dropdownLGUs);
  const pagination = computed(() => store.state.violationType.pagination);
  const title = ref("Violation Types");
  const items = ref([
    {
      text: "Home",
      href: "/"
    },
    {
      text: "Settings",
    },
    {
      text: "Violation Types",
      active: true,
    }
  ])

  const query = ref({
    search: ''        
  })

  const getAllViolationTypes = async (dt) => {
    await store.dispatch('violationType/getViolationTypes', {
      page: dt.page,
      pageSize: dt.per_page ,
      sortColumn: 'updated_at',
      search: dt.search,
      orderBy: 'desc'
    });
  }

  const formattedDate = (date) => {
    return moment(date).format('YYYY-MM-DD h:mm A')
  }

  const getLGU = (id) => {
      if (lgus.value.length > 0) {
        const lgu = lgus.value.find((el) => el.id === id);
        return lgu.name;
      }
      return 'N/A';
  }

  const deleteViolationType = (id, name) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.value) {
          store.dispatch('violationType/deleteViolationType', id);
          Swal.fire("Deleted!", `Violation type ${name} has been successfully deleted!`, "success");
        }
      });
  }

  onMounted(() => {
    store.dispatch('lgu/getDropdownLGUs');
  })
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-overlay :show="loading">
        <div class="d-flex mb-4 justify-content-between">
          <div>
            <h1 class="fs-4 text">Penalties & Violations</h1>
            <small>Set the type of violations and penalties</small>
          </div>
          <div>
             <router-link
                  to="/settings/violation-types/create"
                  class="btn btn-primary right"
                >
                 <i class="ri-add-fill label-icon align-middle fs-16 me-2"></i>
                  New Violation Type
              </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col lg-12">
              <data-table
                  :rows="violationTypes"
                  :pagination="pagination"
                  striped
                  :loading="loading"
                  :query="query"
                  filter
                  hoverable
                  sortable
                  @loadData="getAllViolationTypes"
                >

                <template #thead>
                    <table-head>Name</table-head>
                    <table-head>Article</table-head>
                    <table-head>LGU</table-head>
                    <table-head>Status</table-head>
                    <table-head>Date Modified</table-head>
                    <table-head>Actions</table-head>
                </template>

                <template #tbody="{row}">
                    <table-body v-text="truncate(row.name, { length: 30 })" :title="row.name" />
                    <table-body v-text="truncate(row.article ? row.article : 'N/A', { length: 35 })" :title="row.article" />
                    <table-body v-text="getLGU(row.lgu_id)" />
                    <table-body>
                      <b-badge :variant="row.status ? 'success' : 'danger'">
                        {{ row.status ? 'Active' : 'Inactive' }}
                      </b-badge>
                    </table-body>
                    <table-body v-text="formattedDate(row.updated_at)" />
                    <table-body>
                      <router-link
                          :to="`/settings/violation-types/${row.id}/edit`"
                          class="btn btn-info mr-3"
                          title="Edit"
                        >
                        <i class="ri-pencil-line label-icon align-middle"></i>
                      </router-link>
                      <button class="btn btn-danger" type="button" title="Delete" @click.prevent="deleteViolationType(row.id, row.name)">
                        <i class="mdi mdi-delete label-icon align-middle"></i>
                      </button>
                    </table-body>
                </template>

                <template #empty>
                  <TableBodyCell colspan="10">
                      No Violation Types found.
                  </TableBodyCell>
              </template>
            </data-table>
          </div>
        </div>
      </b-overlay>
  </Layout>
</template>